const KIWI_PATH = "/cne/graphql";
const SENTRY_TRX_NAME = "CNE-MT-Request";
const FETCH_INVENTORY_DETAILS_OP = "fetch-inventory-details";
const FETCH_LEGACY_RESPONSE_OP = "fetch-legacy-response";
const PDP_REQUESTOR_COMPONENT_NAME = "pdp";
const ADD_TO_BAG_PDP_REQUESTOR_COMPONENT_NAME = "a2b-pdp";

export {
  KIWI_PATH,
  SENTRY_TRX_NAME,
  FETCH_INVENTORY_DETAILS_OP,
  FETCH_LEGACY_RESPONSE_OP,
  PDP_REQUESTOR_COMPONENT_NAME,
  ADD_TO_BAG_PDP_REQUESTOR_COMPONENT_NAME,
};
